import { MMButton } from '@components'
import proCardStyles from '@components/DataDisplay/ProCard/ProCard.module.scss'
import { NoTransactions } from '@icons'
import cn from '@integrations/classnames'
import { useNavigate } from '@integrations/routing'
import { paths } from 'mmfintech-backend-api'
import { tr } from 'mmfintech-commons'
import styles from './StaffTransactionsEmpty.module.scss'

interface Props {
  hasAccounts: boolean
  canPay: boolean
}

/** "No transactions yet" on the staff Overview, with the next steps the staff member's permissions allow. */
function StaffTransactionsEmpty({ hasAccounts, canPay }: Props) {
  const navigate = useNavigate()

  const viewAccounts = {
    key: 'accounts',
    caption: tr('FRONTEND.DASHBOARD.STAFF.VIEW_ACCOUNTS', 'View accounts'),
    path: paths.banking.accounts.list()
  }
  const actions = canPay
    ? [
        { key: 'deposit', caption: tr('FRONTEND.DASHBOARD.BUTTON_DEPOSIT', 'Deposit'), path: paths.banking.deposit() },
        viewAccounts
      ]
    : [
        viewAccounts,
        {
          key: 'transactions',
          caption: tr('FRONTEND.DASHBOARD.STAFF.OPEN_TRANSACTIONS', 'Open Transactions'),
          path: paths.banking.transactions.list()
        }
      ]

  const message = !hasAccounts
    ? tr(
        'FRONTEND.DASHBOARD.STAFF.NO_TRANSACTIONS_NO_ACCESS',
        'They’ll show here once an administrator gives you access to an account.'
      )
    : canPay
      ? tr(
          'FRONTEND.DASHBOARD.STAFF.NO_TRANSACTIONS_PAY',
          'Payments on your accounts will show here. A deposit is a good place to start.'
        )
      : tr(
          'FRONTEND.DASHBOARD.STAFF.NO_TRANSACTIONS_VIEW',
          'Payments on your accounts will show here as soon as they happen.'
        )

  return (
    <div
      className={cn(styles['staff-transactions-empty'], 'staff-transactions-empty')}
      data-test='staff-transactions-empty'
    >
      <NoTransactions />
      <h3 className={cn(proCardStyles['pro-card__section-title'], 'pro-card__section-title')}>
        {tr('FRONTEND.DASHBOARD.STAFF.NO_TRANSACTIONS', 'No transactions yet')}
      </h3>
      <p className={cn(proCardStyles['pro-card__empty'], 'pro-card__empty')}>{message}</p>
      {hasAccounts && (
        <div className={cn(styles['staff-transactions-empty__actions'], 'staff-transactions-empty__actions')}>
          {actions.map(({ key, caption, path }, index) => (
            <MMButton
              key={key}
              variant={index === 0 ? 'primary' : 'dashboard'}
              caption={caption}
              onClick={() => navigate(path)}
              data-test={`staff-empty-${key}`}
            />
          ))}
        </div>
      )}
    </div>
  )
}

export default StaffTransactionsEmpty
